import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RolloverFormFactory } from '../rollover-form/rollover-form.factory';
import {
  RolloverNonShareConsiderationOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-non-share-consideration.options';
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";


@Component({
  selector: 'app-rollover-add-non-share-consideration-type-modal',
  templateUrl: './rollover-add-non-share-consideration-type-modal.component.html',
  styleUrls: ['./rollover-add-non-share-consideration-type-modal.component.scss'],
  standalone: false,
})
export class RolloverAddNonShareConsiderationTypeModalComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal,
              public readonly rolloverFormFactory: RolloverFormFactory) {
  }

  get nonShareConsiderations(): AdvancedFormArray<RolloverNonShareConsiderationOptions> {
    return (this.rolloverFormFactory.form.formElements.nonShareConsiderations as AdvancedFormArray<RolloverNonShareConsiderationOptions>);
  }

  get title(): AdvancedFormControl<string, string, string> {
    const nonShareConsiderations = this.nonShareConsiderations;

    return nonShareConsiderations.formGroups[nonShareConsiderations.length - 1].formElements.title as AdvancedFormControl<string, string, string>;
  }

  ngOnInit(): void {
    this.rolloverFormFactory.addNonShareConsideration();
  }

  cancel() {
    this.nonShareConsiderations.pop();
    this.activeModal.close(false);
  }
}
